import { Box, IconButton, useMediaQuery } from '@mui/material';
import MuiDrawer from '@mui/material/Drawer';
import { useState } from 'react';
import { ArrowBackIos, Close } from '@mui/icons-material';
import RightPanelContent from './RightPanelContent';
import { MobileConstants } from '../../constants';
import { SearchTopic } from '../../enum/SearchTopics';

interface RightPanelProps {
  selectedOption: SearchTopic;
  data: any;
  forceOpenDetailTab: number;
}

const RightPanel = (props: RightPanelProps) => {
  const [open, setOpen] = useState(false);
  const isSmallScreen = useMediaQuery(MobileConstants.MOBILE_WIDTH_BREAKPOINT);

  return (
    <>
      {!isSmallScreen && (
        <Box>
          <RightPanelContent
            data={props.data}
            selectedOption={props.selectedOption}
            forceOpenDetailTab={props.forceOpenDetailTab}
          />
        </Box>
      )}
      {isSmallScreen && (
        <>
          <IconButton
            onClick={() => setOpen(!open)}
            sx={{
              justifyContent: 'flex-start',
              width: 'fit-content',
            }}
          >
            <ArrowBackIos />
          </IconButton>
          <MuiDrawer
            open={open}
            variant="temporary"
            anchor="right"
            sx={{
              pt: 4,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            <IconButton
              onClick={() => setOpen(false)}
              sx={{
                position: 'absolute',
                left: 0,
                top: 0,
              }}
            >
              <Close />
            </IconButton>
            <RightPanelContent
              data={props.data}
              selectedOption={props.selectedOption}
              forceOpenDetailTab={props.forceOpenDetailTab}
            />
          </MuiDrawer>
        </>
      )}
    </>
  );
};

export default RightPanel;
